import createLocationModel from './lib/create_location_model';

export default createLocationModel({
  modelName: 'UserActivation',
  properties: {},
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/user_activation.js